import React from 'react';
import {Section} from '../section/Section';
import css from './MIDIDeviceSetupSection.module.scss';
import {Button} from 'react-bootstrap/lib/InputGroup';
import {ButtonV2} from '../../../system/ButtonV2/ButtonV2';
import {faExternalLinkAlt, faLink} from '@fortawesome/free-solid-svg-icons';
import {ScrollService} from '../ScrollService';

export const MIDIDeviceSetupSection: React.FC<{scroller: ScrollService}> = ({
  scroller,
}) => {
  return (
    <Section title="MIDI Device Setup" number={3} type="midi-device-setup">
      <div className={css.install_midi_container}>
        <div>
          <div className={css.title}>
            Install software to create MIDI loopback port
          </div>
          <div className={css.subtitle}>
            Download and install on your PC a software for virtual MIDI loopback
            — loopMIDI or similar.
          </div>
        </div>
        <div className={css.button}>
          <ButtonV2
            prefixIcon={faExternalLinkAlt}
            href="https://www.tobias-erichsen.de/software/loopmidi.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download loopMIDI
          </ButtonV2>
        </div>
      </div>

      <div className={css.create_midi_container}>
        <div className={css.title}>
          Create virtual MIDI device, named “pulsoidmidi”
        </div>
        <div className={css.subtitle}>
          In your MIDI loopback software, create a virtual loopback MIDI port to
          <br></br> broadcast your heart rate from this page to VRChat
        </div>
        <div className={css.animation_guide}>
          <img src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/vrchat-worlds/midi-setup-page/pulsoidmidi-create-loopback.gif" />
        </div>
        <div className={css.caption}>
          How to create a virtual MIDI device in loopMIDI
        </div>
      </div>
      <div className={css.install_midi_container}>
        <div>
          <div className={css.tile}>
            Connect a virtual MIDI port to this page
          </div>
          <div className={css.tile}>
            Use <span className={css.pulsoidmidi}>‘pulsoidmidi’</span> in the
            name to auto-connect to this page
          </div>
          <div className={css.subtitle}>
            If you are unable to use this name for any reason, please report the
            issue to us.
          </div>
        </div>
        <div className={css.button}>
          <ButtonV2 onClick={() => scroller.scroll('midi-device-search')}>
            Try to connect to pulsoidmidi
          </ButtonV2>
        </div>
      </div>
    </Section>
  );
};
